import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../components/common/SafeIcon';

const Features = () => {
  const features = [
    {
      title: "Patient Literacy Scripts",
      desc: "Stop struggling with what to say. Our specialized AI generates accurate, easy-to-understand explanations for complex dental procedures.",
      icon: FiIcons.FiBookOpen,
      color: "bg-blue-100 text-blue-600"
    },
    {
      title: "Hyper-Realistic Avatars",
      desc: "Choose from a diverse library of professional avatars that speak your script with perfect lip-sync and natural gestures.",
      icon: FiIcons.FiUsers,
      color: "bg-purple-100 text-purple-600"
    },
    {
      title: "Omni-Channel Posting",
      desc: "Automatically format and post your videos to Instagram Reels, TikTok, YouTube Shorts, and LinkedIn with a single click.",
      icon: FiIcons.FiShare2,
      color: "bg-pink-100 text-pink-600"
    },
    {
      title: "Studio B-Roll Integration",
      desc: "Enhance videos with AI-generated B-roll or upload your own clinic footage to showcase your actual practice environment.",
      icon: FiIcons.FiFilm,
      color: "bg-orange-100 text-orange-600"
    },
    {
      title: "Testimonial Generator",
      desc: "Turn written patient reviews into engaging video content using avatars to represent satisfied patients (with disclaimer support).",
      icon: FiIcons.FiStar,
      color: "bg-yellow-100 text-yellow-600"
    },
    {
      title: "Brand Customization",
      desc: "Add your clinic's logo, custom intros/outros, and brand colors to every video to maintain professional consistency.",
      icon: FiIcons.FiLayout,
      color: "bg-cyan-100 text-cyan-600"
    }
  ];

  return (
    <div className="bg-slate-50 min-h-screen">
      <div className="bg-slate-900 text-white py-20 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Powerful Features for Modern Practices</h1>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto">Everything you need to automate your video marketing and patient education.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-16 pb-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.1 }}
              className="bg-white p-8 rounded-2xl shadow-lg border border-slate-100 hover:shadow-xl transition-all"
            >
              <div className={`w-14 h-14 ${feature.color} rounded-xl flex items-center justify-center text-2xl mb-6`}>
                <SafeIcon icon={feature.icon} />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{feature.title}</h3>
              <p className="text-slate-600 leading-relaxed">{feature.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;